import { GlobalService } from 'src/app/_services/global.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/_services/login.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CreateTalentpoolComponent } from '../talentpool/create-talentpool/create-talentpool.component';
import { CreateCandidateComponent } from './../candidate/create-candidate/create-candidate.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { TransactionService } from '../_services/transaction.service';
declare const clevertap;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  successMessage: any;
  errorMessage: string;
  candidateSubject:Subject<any> = new Subject();
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  userdata: any
  routeCheckForScrollNavabar:any
  planRefreshInterval: any = null;

  constructor(public modalService: NgbModal,private _localstorageservice : LocalStorageService ,private loginservice : LoginService,
    private router : Router ,private transactionservice:TransactionService) { }

  ngOnInit() {
    this.userdata = this._localstorageservice.getItem('userdata')
    this.transactionservice.updateAllCreditsForCurrentUser().subscribe(); // fetch latest plan details of user
    this.transactionservice.getPaymentData().subscribe(event => {
      this.userdata = this._localstorageservice.getItem('userdata')
    });
    
    this.routeCheckForScrollNavabar=  this.router.url.includes('/person/search/listing')

    // call fetchcurrentplans details every 2 mins to refresh credits
    this.planRefreshInterval = setInterval(() => {
      this.transactionservice.updateAllCreditsForCurrentUser().subscribe(); // fetch latest plan details of user
    }, 2*60*1000);
  }

  ngOnDestroy() {
    clearInterval(this.planRefreshInterval);
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  
  openCreateCandidate(){
    // const modalRef = this.modalService.open(CreateCandidateComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,windowClass: 'custom-class' });
    document.getElementById("mySidebar").style.display = "block";
    document.getElementById("myOverlay").style.display = "block";
    this.candidateSubject.next();

  }

  openCreateTalentpool(){
    if(this._localstorageservice.getItem('tpcredits') > 0){
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'talentpool-added') {
        this.toastmessage('Talentpool Created Succesfully', 'success')
        this.fetchcredits()
    }else if(x == 'notpcredits'){
      const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
      this.sendmailexpiry('Talent Pipeline credits')
    }
    else if(x =='error'){
      this.toastmessage('Something went wrong, Please try again in a minute', 'error')
    }})
    }else{
      let clevertap_data = {
        "Talent Pool Name" : 'null',
      }
      this.cleverTapEvent("TalentPool_CreditExpiry", clevertap_data);
      const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
      this.sendmailexpiry('Talent Pipeline credits')
    }
  }

  logout(){
  let userid = this._localstorageservice.getItem('userid')
  let userno = this._localstorageservice.getItem('usernumber')
  let ufname = this._localstorageservice.getItem('ufname')
  let ulname = this._localstorageservice.getItem('ulname')
  
   let data ={
     email : "'" + this._localstorageservice.getItem('usermailid') + "'"
   }
   this.loginservice.logOut(data).subscribe((res:any)=>{
     if(res.status == 'success'){
      let chromeid = localStorage.getItem('extensionID');
      if(chromeid){
      try {
        window['chrome'].runtime.sendMessage(chromeid, {action: 'logout', usernumber: userno, userid: userid, firstname: ufname, lastname: ulname});
       }
       catch (error) {
        console.error('Here is the error message', error);
       }
      }
      this.router.navigateByUrl('/login')
      localStorage.clear()
      localStorage.setItem('extensionID', chromeid)
     }
   })

  }

  route2pricing(){
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/usage')
  }

  fetchcredits(){
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res:any)=>{
      if(res.status == 'success'){
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.isteamMember = true
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
    })
  }

  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }
  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  initiatechat() {
    const user = this._localstorageservice.getItem('ufname') + ' ' + this._localstorageservice.getItem('ulname')
    const user_email = this._localstorageservice.getItem('usermailid')
    if(window['fcWidget']) {
      window['fcWidget'].setExternalId(user_email);

      window['fcWidget'].user.setFirstName(user);
      window['fcWidget'].user.setEmail(user_email);
      window['fcWidget'].user.setProperties({
        plan: "Pro",                 
        status: "Active"             
      });
    
      if(window['fcWidget'].isOpen()) {
        window['fcWidget'].close()
      } else {
        window['fcWidget'].open()
      }
    }

  }
}
